var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Transition",
    {
      attrs: { name: "slide-fade" },
      on: {
        enter: _vm.onTransitionEnter,
        "after-leave": _vm.onTransitionAfterLeave,
      },
    },
    [
      _vm.isOpen
        ? _c(
            "div",
            {
              staticClass:
                "position-fixed left-0 top-0 w-100 h-100 z-index-500 d-flex flex-row user-modal-container",
              class: _vm.containerClass,
            },
            [
              _c("div", {
                staticClass: "col-sm-2 col-md-2 col-lg-1 hidden-xs",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.closeModal.apply(null, arguments)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "bg-gray-light p-10 d-flex flex-grow-1 position-relative",
                  class: _vm.contentWrapperClass,
                  attrs: { id: _vm.identifier + "-content" },
                },
                [
                  _c("span", {
                    staticClass:
                      "position-absolute cursor-pointer user-modal-close",
                    attrs: { "data-user-modal-close": "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.closeModal.apply(null, arguments)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex w-100 align-items-center justify-content-center overflow-auto",
                    },
                    [
                      _c("div", { attrs: { id: "promiseCaptchaContainer" } }),
                      _vm._v(" "),
                      _vm.isLoading
                        ? _c("LoadingAnimation", {
                            attrs: {
                              "animation-style": "bars",
                              id: "user-modal-loading-animation",
                            },
                          })
                        : [
                            _c(
                              "Transition",
                              { attrs: { name: _vm.transitionName } },
                              [
                                _c(
                                  "KeepAlive",
                                  { attrs: { include: _vm.keepAliveViews } },
                                  [
                                    _c("RouterView", {
                                      key: _vm.$route.fullPath,
                                      staticClass: "h-max-100 py-3",
                                      on: { "modal-close": _vm.closeModal },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                    ],
                    2
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }